import { render, staticRenderFns } from "./preventionIndex.vue?vue&type=template&id=7f52a9e8&scoped=true&"
import script from "./preventionIndex.vue?vue&type=script&lang=js&"
export * from "./preventionIndex.vue?vue&type=script&lang=js&"
import style0 from "./preventionIndex.vue?vue&type=style&index=0&id=7f52a9e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f52a9e8",
  null
  
)

export default component.exports